import { render, staticRenderFns } from "./DialogInfoRede.vue?vue&type=template&id=5e29d422&"
import script from "./DialogInfoRede.vue?vue&type=script&lang=js&"
export * from "./DialogInfoRede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports